export const showPremiumCamCTA = ({ spot, hasPremiumCamPermissions }) => {
  const [camera] = spot.cameras;
  if (!camera) return false;

  return camera.isPremium && !hasPremiumCamPermissions;
};
